export function createSplashScreen() {

    const div = document.createElement("div");
    div.id = "splash";

    Object.assign(div.style, {
        background: Q3.nouicontrols ? "transparent" : "#8594a2",
        width: "100%",
        height: "100%",
        position: "absolute",
        top: "0",
        left: "0",
        zIndex: "1000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column"
    });
    const splash = document.createElement("img");
    splash.src = "/images/icons/CooBo.svg";

    Object.assign(splash.style, {
        fontSize: "50px",
        color: "#d4ebff",
        marginBottom: "5px",
        height: "60px"
    });

    const splashTitle = document.createElement("div");
    const splashCaption = document.createElement("div");

    splashTitle.innerText = Q3.data.title;
    //splashCaption.innerText = Q3.data.subtitle || "";

    // div.appendChild(splashTitle);
    // div.appendChild(splashCaption);

    splashTitle.classList.add("splash-info", "title");
    splashCaption.classList.add("splash-info", "caption");

    div.appendChild(splash);

    const progressBar = document.createElement("span");
    const progressValue = document.createElement("span");

    Object.assign(progressBar.style, {
        width: "0px",
        height: "8px",
        background: "#fff",
    });

    Object.assign(progressValue.style, {
        color: "#ffffff"
    });

    div.progress = progressBar;
    div.progressValue = progressValue;
    progressValue.innerText = "Initializing...";

    div.appendChild(progressBar);
    div.appendChild(progressValue);

    div.className = "splash-screen"

    return div;

}